import { useEffect } from "react";

interface useCreateShopUrlTriggerProps {
  canCreateShop: boolean;
  onCreateShop: () => void;
}

export default function useCreateShopUrlTrigger({
  canCreateShop,
  onCreateShop,
}: useCreateShopUrlTriggerProps) {
  useEffect(() => {
    if (!canCreateShop) return;
    const params = new URLSearchParams(window.location.search);
    if (params && params.has("create-shopify-shop")) {
      onCreateShop();
    }
  }, [canCreateShop, onCreateShop]);
}
